module.exports = __webpack_public_path__ + "static/media/semVinculos.9484e8ec.PNG";